import { SearchIcon } from "lucide-react";
import * as React from "react";
import { useFormContext } from "react-hook-form";
import { DriveSearchFormInputs, SearchMode } from "./types";

interface Props {
  searchMode: SearchMode;
}

export const SearchInput: React.FC<Props> = ({ searchMode }) => {
  const { register } = useFormContext<DriveSearchFormInputs>();

  const placeholder =
    searchMode === "ai"
      ? "Ask anything... e.g., 'contracts from last quarter' or 'budget proposals'"
      : "Search files and folders";

  return (
    <div className="relative">
      <input
        type="text"
        {...register("query")}
        placeholder={placeholder}
        className="h-11 w-full rounded-md border border-gray-300 bg-white py-2 pl-10 pr-3 text-sm transition-colors focus:border-coral focus:outline-none focus:ring-2 focus:ring-coral/20"
      />
      <SearchIcon className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
    </div>
  );
};
